import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CHeader,
  CToggler,
  CHeaderBrand,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CSubheader,
  CBreadcrumbRouter,
  CCol,
  CSwitch,
  CNavItem,
  CBadge,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";

// routes config
import {
  adminRoutes,
  branchRoutes,
  deliveryRoutes,
  offlineRoutes,
  orderRoutes,
} from "../../routing/Routes";
import { TheHeaderDropdown } from "./index";
import { changeStatus } from "src/modules/User/actions";
import Badge from "../Branch/orders/Badge";

const TheHeader = () => {
  const dispatch = useDispatch();
  const sidebarShow = useSelector((state) => state.sidebar.sidebarShow);
  const status = useSelector((state) => state.auth?.executive.status);
  const toggleSidebar = () => {
    const val = [true, "responsive"].includes(sidebarShow) ? false : true;
    dispatch({ type: "set", sidebarShow: val });
  };

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebarShow) ? true : false;
    dispatch({ type: "set", sidebarShow: val });
  };

  const role = useSelector((state) => state.auth.user.role);

  const executives = [
    "deliveryexecutive",
    "offlineexecutive",
    "orderexecutive",
  ];

  const getRoute = () => {
    if (role === "admin") {
      return adminRoutes;
    } else if (role === "branch") {
      return branchRoutes;
    } else if (role === "deliveryexecutive") {
      return deliveryRoutes;
    } else if (role === "offlineexecutive") {
      return offlineRoutes;
    } else if (role === "orderexecutive") {
      return orderRoutes;
    }
  };

  return (
    <CHeader withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="ml-3 d-md-down-none"
        onClick={toggleSidebar}
      />
      <CHeaderBrand className="mx-auto d-lg-none" to="/">
        <CIcon name="logo" height="48" alt="Logo" />
      </CHeaderBrand>

      <CHeaderNav className="d-md-down-none mr-auto">
        <CHeaderNavItem className="px-3">
          <CHeaderNavLink to="/" style={{ textTransform: "capitalize" }}>
            {role} Dashboard
          </CHeaderNavLink>
        </CHeaderNavItem>
      </CHeaderNav>

      <CHeaderNav className="px-3">
        <TheHeaderDropdown />
      </CHeaderNav>

      <CSubheader className="justify-content-between">
        <CBreadcrumbRouter
          className="border-0 c-subheader-nav m-0 px-0 px-md-3"
          routes={getRoute()}
        />
        {executives.includes(role) ? (
          <div style={{ margin: "10px" }}>
            <Badge
              text={status ? "Active" : "Inactive"}
              bgColor={status ? "green" : "grey"}
              fontColor="white"
            />
          </div>
        ) : (
          ""
        )}

        {/* {executives.includes(role) ? (
          <div
            className="mr-3 mt-2"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <h5
              className="mr-3"
              style={{
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
              }}
            >
              Status
            </h5>
            <div>
              <CSwitch
                checked={status ? true : false}
                variant="3d"
                color="success"
                onChange={() => dispatch(changeStatus(!status))}
              />
            </div>
          </div>
        ) : (
          ""
        )} */}
      </CSubheader>
    </CHeader>
  );
};

export default TheHeader;
